/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */
import * as api from '@/api/user';
import { USER } from '@/store/types';
import { ImUserInfo } from '@/api/types/user';
import { StoreActionEnv } from '@/store/actions';

export interface StoreUserImState {
  appid: number;
  uid: string;
  sig: string;
  expire: number;
  users: Record<string, ImUserInfo>;
}

export default {
  namespaced: true,
  state: {
    appid: '',
    uid: '',
    sig: '',
    expire: 0,
    users: {},
  },
  getters: {},
  actions: {
    [USER.GET_IM_SIG](
      { state, commit }: StoreActionEnv<StoreUserImState>,
      { reload = true, silent }: { reload?: boolean; silent?: boolean } = {},
    ) {
      if (!state.sig || new Date().valueOf() > state.expire) {
        reload = true;
      }
      if (reload) {
        return new Promise((resolve, reject) => {
          api.getImUserSig(silent).then((res) => {
            commit(USER.GET_IM_SIG, {
              appid: res.data.appid,
              uid: res.data.uid,
              sig: res.data.sig,
              expire: new Date().valueOf() + res.data.expired * 100,
            });
            resolve();
          }).catch(reject);
        });
      }
      return Promise.resolve();
    },
    [USER.GET_IM_USER_INFO](
      { state, commit }: StoreActionEnv<StoreUserImState>,
      { reload = false, silent = false, uids }: { reload?: boolean; silent?: boolean; uids: string[] },
    ) {
      const ruids = uids.filter(uid => !state.users[uid] || reload);
      if (ruids.length !== 0) {
        reload = true;
      }
      if (reload) {
        return new Promise((resolve, reject) => {
          api.getImUserInfo(ruids, silent).then((res) => {
            commit(USER.GET_IM_USER_INFO, {
              infos: res.data,
            });
            resolve();
          }).catch(reject);
        });
      }
      return Promise.resolve();
    },
  },
  mutations: {
    [USER.GET_IM_SIG](state: StoreUserImState, { appid, uid, sig, expire }) {
      state.appid = appid;
      state.uid = uid;
      state.sig = sig;
      state.expire = expire;
    },
    [USER.GET_IM_USER_INFO](state: StoreUserImState, { infos }: { infos: ImUserInfo[] }) {
      state.users = Object.assign({}, state.users, infos);
    },
  },
};
